import ModelSubNavigation from './ModelSubNavigation';
import TrimSubNavigation from './TrimSubNavigation';
import FeatureSubNavigation from './FeatureSubNavigation';
import { renderVariantStyle } from '../../utils/abTesting';
import { AB_TESTING_CAMPAIGNS } from '../../constants';

export default class ModSubNavigation {
  constructor(el) {
    this.el = el;
    this.$el = $(el);
    this.dom = {
      $features: $('[data-module="Features"]'),
    };
    this.init();
  }

  init() {
    if (this.dom.$features.length) {
      this.features = new FeatureSubNavigation(this.el);
      this.$el.addClass('feature-template');
    } else if (this.$el.hasClass('trim-template')) {
      this.trims = new TrimSubNavigation(this.el);
    } else {
      this.models = new ModelSubNavigation(this.el);
    }
    this.runABTesting();
  }

  runABTesting() {
    const variants = {
      [AB_TESTING_CAMPAIGNS.RAQ.variants.a]: 'btn btn-ani btn-primary w-full py-6 xl:py-0 xl:m-0 whitespace-nowrap',
      [AB_TESTING_CAMPAIGNS.RAQ.variants.b]: 'btn btn-ani btn-black w-full py-6 xl:py-0 xl:m-0 whitespace-nowrap',
    };
    renderVariantStyle(
      AB_TESTING_CAMPAIGNS.RAQ.campaignName,
      variants,
      document.getElementById('abt-cta-get-my-quote'),
      AB_TESTING_CAMPAIGNS.RAQ.variants.a,
    );
    document.getElementById('abt-cta-get-my-quote').setAttribute('data-abt-campaign', AB_TESTING_CAMPAIGNS.RAQ.campaignName);
  }
}
